function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 16a5.811 5.811 0 00-3.029-5.147.332.332 0 01-.16-.385 5.888 5.888 0 00-7.279-7.28.332.332 0 01-.385-.16 5.89 5.89 0 00-10.294 0 .332.332 0 01-.385.16 5.888 5.888 0 00-7.279 7.28.332.332 0 01-.16.385 5.887 5.887 0 000 10.293.335.335 0 01.16.387 5.888 5.888 0 007.279 7.279c.15-.044.31.023.385.16a5.89 5.89 0 0010.294 0 .332.332 0 01.385-.16 5.887 5.887 0 007.279-7.279.336.336 0 01.16-.387A5.805 5.805 0 0032 15.999zm-11.123 7.315a2.438 2.438 0 112.437-2.44v.003a2.438 2.438 0 01-2.437 2.437zm-10.438.133a1.333 1.333 0 01-1.881-1.881L21.562 8.563a1.333 1.333 0 111.881 1.881zm.685-14.763a2.439 2.439 0 11-2.439 2.439v-.001a2.439 2.439 0 012.439-2.437z"
});

function SvgOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgOffer;